import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useEffect } from 'react';
import { useCallbacks, usePartial } from 'shared/hooks/utils';
import { open_configured_dialog } from 'console/baxi/entities/master-settings/redux/actions';
import { close_z3k_settings } from 'z3k-settings/redux/actions';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import branding from 'shared/app/model/branding';
import { Alert, Button } from '@mui/material';
import Wand from 'console/baxi/entities/master-settings/wizardIcons/wandIcon.svg';
import { StockConfigs, } from 'console/device-settings/z3k/components/main-settings/stock-configs/configs';
import { load_stock_configs } from 'console/device-settings/z3k/components/main-settings/stock-configs/redux/actions';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
import { useNavigateTo } from 'shared/hooks/router';
import { selectDevice } from 'entities/device/lib';
import { SettingCard, SettingFullRow } from '../../material-utils/settings-card';
export const StockConfigsCard = memo(function StockConfigCard(props) {
    const { device_spec, device_id } = useContext(Z3KSettings);
    const showBaxiWizard = device_spec.has_baxi_wizard_configured;
    const allowWizard = device_spec.allow_wizard_configuration;
    const is_configured_by_wizard = useAppSelector((state) => selectDevice(state, device_id))?.is_configured_by_wizard;
    const configured = useCallbacks([
        useAction(open_configured_dialog),
        useAction(usePartial(close_z3k_settings, props.device_id)),
    ]);
    const library = useAppSelector((state) => state.stock_configs.library);
    const by_type = library[props.device_type];
    const loading = by_type?.loading;
    const loaded = by_type?.configs != null;
    const loadStockConfig = useAction(load_stock_configs);
    useEffect(() => {
        if (!loaded && !loading) {
            loadStockConfig(props.device_type);
        }
    }, [props.device_type]);
    const showStockConfigs = loaded && by_type?.configs?.length != null && by_type.configs.length != 0;
    const goToWarning = useNavigateTo(`/master-settings/warning`);
    const goToMaster = useNavigateTo(`/master-settings/list/1`);
    if (!branding.show_master_settings) {
        return null;
    }
    if (!allowWizard && !showBaxiWizard && !showStockConfigs) {
        return null;
    }
    return (_jsxs(SettingCard, { title: "\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F", children: [_jsx(SettingFullRow, { children: _jsx(Alert, { severity: "info", sx: { width: '100%' }, children: "\u0421\u0430\u043C\u044B\u0435 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043B\u044F \u0412\u0430\u0448\u0435\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430" }) }), showStockConfigs && (_jsx(SettingFullRow, { children: _jsx(StockConfigs, { ...props }) })), showBaxiWizard ? (_jsx(Button, { variant: "contained", size: "large", startIcon: _jsx(Wand, { width: 20, height: 20 }), onClick: configured, children: "\u041C\u0430\u0441\u0442\u0435\u0440 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u043A\u043E\u0442\u043B\u0430" })) : (allowWizard && (_jsx(SettingFullRow, { children: _jsx(Button, { variant: "contained", size: "large", color: "heat", startIcon: _jsx(Wand, { width: 20, height: 20 }), onClick: is_configured_by_wizard ? goToWarning : goToMaster, fullWidth: true, children: "\u041C\u0430\u0441\u0442\u0435\u0440 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A" }) })))] }));
});
